export default "__VITE_ASSET__B0PZT5z2__"